import { render } from "./BI.vue?vue&type=template&id=6c2b2d80"
import script from "./BI.vue?vue&type=script&lang=js"
export * from "./BI.vue?vue&type=script&lang=js"

import "./BI.vue?vue&type=style&index=0&id=6c2b2d80&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__